import { useEffect, useMemo } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import ArticleCard from '@/components/feature/ArticleCard';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

const ARTICLE_CONTENT: Record<string, { sections: { heading: string; paragraphs: string[] }[] }> = {
  'yindao-jiegou-jiepou': {
    sections: [
      {
        heading: '阴道的基本解剖位置',
        paragraphs: [
          '阴道是女性生殖系统的重要组成部分，是一条富有弹性的肌性管道，连接子宫和外生殖器。它位于盆腔内，前方与膀胱和尿道相邻，后方与直肠相邻。阴道的长度通常在7-9厘米左右，但在性兴奋和分娩时可以显著扩张。',
          '阴道壁由三层组织构成：最内层是粘膜层，中间是肌层，最外层是纤维层。粘膜层表面覆盖着复层扁平上皮，这些细胞含有丰富的糖原，正是这些糖原为阴道内的乳酸杆菌提供了养分。',
        ],
      },
      {
        heading: '阴道口与处女膜',
        paragraphs: [
          '阴道口位于尿道口下方，是阴道与外界相通的开口。在阴道口周围，有一层薄膜组织称为处女膜。处女膜的形态因人而异，有环形、半月形、筛状等多种形态。需要注意的是，处女膜的完整与否并不能作为判断是否有过性行为的依据，因为剧烈运动、骑自行车等活动也可能导致处女膜破裂。',
          '有些女性天生处女膜较厚或完全闭锁，这种情况可能导致经血排出困难，需要及时就医处理。',
        ],
      },
      {
        heading: '阴道的自洁功能',
        paragraphs: [
          '阴道具有强大的自洁功能，这是维持女性私密健康的关键机制。阴道粘膜上皮细胞在雌激素的作用下不断增生、脱落，脱落的细胞中含有糖原，被阴道内的乳酸杆菌分解后产生乳酸，使阴道环境维持在弱酸性状态（pH 3.8-4.5）。',
          '这种酸性环境能有效抑制大多数病原体的生长和繁殖，是女性身体天然的第一道防线。因此，正常情况下不需要任何人为的灌洗来"清洁"阴道内部，过度清洁反而会破坏这一精妙的平衡。',
        ],
      },
      {
        heading: '认识你的身体，从接纳开始',
        paragraphs: [
          '很多女性对自己的生殖系统了解甚少，甚至从未看过自己的外阴。了解自己的生理结构不是羞耻的事情，而是每个女性应有的基本健康素养。建议每位女性可以在私密的环境中，使用镜子观察自己的外阴形态，了解正常的结构，这样当出现异常变化时能够及时发现。',
          '建立正确的身体认知，是女性自我关爱和健康管理的第一步。',
        ],
      },
    ],
  },
  'yindao-yan-zhonglei': {
    sections: [
      {
        heading: '霉菌性阴道炎（外阴阴道假丝酵母菌病）',
        paragraphs: [
          '霉菌性阴道炎是最常见的阴道炎类型之一，由假丝酵母菌（念珠菌）过度繁殖引起。典型症状包括外阴剧烈瘙痒、灼痛感，以及白色豆腐渣样或凝乳状分泌物。很多女性形容这种瘙痒感"让人坐立难安"。',
          '诱发因素包括：长期使用抗生素、怀孕、未控制的糖尿病、口服避孕药、免疫力低下等。这些因素都会改变阴道内环境，为霉菌的繁殖创造条件。值得注意的是，霉菌性阴道炎不是性传播疾病，即使没有性生活的女性也可能患上。',
          '治疗方面，医生通常会开具抗真菌药物，包括阴道栓剂、外用药膏或口服药物。治疗期间应避免性生活，同时注意内裤的消毒处理，防止反复感染。',
        ],
      },
      {
        heading: '细菌性阴道病',
        paragraphs: [
          '细菌性阴道病是由于阴道内厌氧菌过度繁殖、乳酸杆菌减少导致的菌群失衡状态。最典型的症状是带有鱼腥味的灰白色稀薄分泌物，尤其在性生活后气味更加明显。与霉菌性阴道炎不同，细菌性阴道病通常瘙痒症状较轻甚至没有。',
          '风险因素包括：频繁阴道灌洗、多个性伴侣、吸烟、使用宫内节育器等。这些行为都会干扰阴道正常的菌群平衡。细菌性阴道病虽然不是严重的疾病，但若不及时治疗，可能增加盆腔炎、早产以及感染HIV等性传播疾病的风险。',
          '治疗主要使用甲硝唑或克林霉素，有口服和阴道用药两种方式。完成全程治疗非常重要，即使症状消失也不应提前停药，否则容易复发。',
        ],
      },
      {
        heading: '滴虫性阴道炎',
        paragraphs: [
          '滴虫性阴道炎由阴道毛滴虫感染引起，是唯一一种通过性接触传播的阴道炎类型。典型症状为大量黄绿色泡沫状分泌物，伴有明显的腥臭味和外阴瘙痒、灼痛感。有些女性还会出现尿频、尿痛等泌尿系统症状。',
          '滴虫性阴道炎的诊断需要通过白带常规检查确认。治疗采用甲硝唑或替硝唑，且性伴侣需要同时治疗，否则容易反复交叉感染。治疗期间及治疗结束后一周内应避免饮酒，因为甲硝唑与酒精会产生不良反应。',
        ],
      },
      {
        heading: '如何区分三种阴道炎？',
        paragraphs: [
          '三种常见阴道炎虽然都有分泌物异常和外阴不适的症状，但在具体表现上有明显差异。霉菌性阴道炎的分泌物呈白色豆腐渣样，瘙痒最为剧烈；细菌性阴道病分泌物呈灰白色稀薄状，有鱼腥味；滴虫性阴道炎分泌物呈黄绿色泡沫状，腥臭味明显。',
          '由于症状可能存在重叠，而且混合感染并不少见，不建议根据症状自行判断和用药。错误的治疗不仅无效，还可能加重病情。出现异常症状时，最稳妥的做法是去医院做白带常规检查，根据检查结果进行针对性治疗。',
        ],
      },
    ],
  },
  'si-chu-qingjie-zhengque': {
    sections: [
      {
        heading: '日常清洁的核心原则',
        paragraphs: [
          '私处清洁最重要的原则是：只需要清洁外阴，不需要灌洗阴道内部。阴道具有强大的自洁功能，乳酸杆菌维持的弱酸性环境本身就是最好的防御系统。任何灌洗行为都会破坏这一天然屏障。',
          '正确的清洁方法非常简单：每天用流动的温水清洗外阴一次即可。清洗前一定要先洗净双手，按照从前向后的方向清洗，避免将肛门区域的细菌带到阴道口。不需要使用任何沐浴露、香皂或洗液清洗阴道内部。',
        ],
      },
      {
        heading: '洗液使用的常见误区',
        paragraphs: [
          '市面上琳琅满目的女性护理液常常宣称能够"杀菌"、"除味"、"清爽"，但大多数妇科医生并不推荐日常使用。原因很简单：这些产品大多呈碱性或含有抗菌成分，会杀死有益的乳酸杆菌，破坏阴道正常的酸性环境。',
          '即便是标注为"弱酸性"的护理液，其成分中也往往含有香料、防腐剂等可能刺激私处粘膜的物质。健康的阴道不需要任何外来的"清洁剂"。只有在医生明确建议的情况下（如某些手术后），才需要按照医嘱使用特定的医用洗液。',
        ],
      },
      {
        heading: '经期和性生活后的清洁',
        paragraphs: [
          '经期清洁需要更加注意，建议每天清洗外阴1-2次，每2-4小时更换卫生巾。血液是细菌的良好培养基，长时间不更换卫生巾会增加感染风险。清洗时同样只需要用温水清洗外阴即可。',
          '性生活后，建议及时排尿并用温水清洗外阴。排尿可以利用尿液的冲刷作用减少尿道细菌上行感染的风险。不需要进行阴道灌洗，因为精液和阴道分泌物会自然排出。如果使用润滑剂，选择水性、无香料的产品更为安全。',
        ],
      },
    ],
  },
  'fuke-jiancha-xiangmu': {
    sections: [
      {
        heading: '白带常规检查',
        paragraphs: [
          '白带常规是妇科最基本也是最常见的检查项目。医生会用棉签在阴道内取少量分泌物样本，通过显微镜观察其中的细胞成分和微生物情况。检查报告通常包括清洁度、霉菌、滴虫、线索细胞等指标。',
          '清洁度分为I-IV级：I-II级为正常，III级提示可能存在轻度炎症，IV级则表示有明显感染。如果报告显示有霉菌孢子或菌丝，说明存在霉菌感染；如果发现滴虫，则诊断为滴虫性阴道炎；线索细胞阳性则提示细菌性阴道病。',
        ],
      },
      {
        heading: 'HPV检测',
        paragraphs: [
          'HPV（人乳头瘤病毒）检测用于筛查宫颈癌的风险。目前已知有200多种HPV亚型，其中约14种高危型与宫颈癌密切相关。HPV检测通常与TCT检查同时进行，称为"联合筛查"。',
          '需要强调的是，HPV感染非常普遍，大多数女性一生中都会感染HPV，但绝大多数感染会在1-2年内被免疫系统自行清除。只有持续的高危型HPV感染才会增加宫颈癌风险。因此，HPV阳性结果不要过度恐慌，应遵医嘱进一步检查或定期随访。',
        ],
      },
      {
        heading: 'TCT宫颈细胞学检查',
        paragraphs: [
          'TCT（液基薄层细胞学检测）是目前最常用的宫颈癌筛查方法。医生使用小刷子在宫颈口采集细胞样本，通过特殊技术制成薄层细胞涂片，在显微镜下观察细胞形态是否异常。',
          'TCT报告通常使用TBS分类系统，结果包括：未见上皮内病变或恶性细胞（正常）、非典型鳞状细胞（需要进一步检查）、低级别或高级别鳞状上皮内病变等。如果TCT结果异常，医生会根据具体情况建议进行阴道镜检查或宫颈活检。',
        ],
      },
      {
        heading: '读懂你的检查报告',
        paragraphs: [
          '拿到检查报告后，不要自行上网搜索诊断，不同检查项目的异常结果意义不同，需要医生结合临床症状综合判断。例如，白带清洁度III级在某些情况下可能只是暂时性的菌群波动，不一定需要治疗。',
          '建议在检查前准备好想咨询的问题，拿报告时主动向医生询问：我的结果正常吗？哪项指标异常？需要治疗吗？需要多久复查一次？这样才能充分利用就医时间，获得最有效的健康指导。',
        ],
      },
    ],
  },
};

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [slug]);

  const article = useMemo(() => articles.find((a) => a.slug === slug), [slug]);
  const category = useMemo(
    () => (article ? categories.find((c) => c.slug === article.category) : undefined),
    [article]
  );
  const content = slug ? ARTICLE_CONTENT[slug] : undefined;

  const relatedArticles = useMemo(() => {
    if (!article) return [];
    return articles.filter((a) => a.category === article.category && a.id !== article.id).slice(0, 3);
  }, [article]);

  if (!article) {
    return (
      <div className="min-h-screen">
        <Navbar />
        <main className="pt-16 flex items-center justify-center h-96">
          <div className="text-center">
            <h1 className="font-heading text-2xl text-foreground-900 mb-4">文章未找到</h1>
            <Link to="/" className="text-primary-600 hover:text-primary-700 text-sm">
              返回首页
            </Link>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  const getCategoryName = (catSlug: string) => {
    const cat = categories.find((c) => c.slug === catSlug);
    return cat ? cat.name : '';
  };

  const articleJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.excerpt,
    image: article.image,
    datePublished: article.publishedAt,
    author: {
      '@type': 'Organization',
      name: '女性私密健康指南',
    },
    publisher: {
      '@type': 'Organization',
      name: '女性私密健康指南',
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `https://readdy.ai/article/${article.slug}`,
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(articleJsonLd)}</script>
      <div className="min-h-screen">
        <Navbar />
        <main className="pt-16">
          <article>
            <div className="max-w-[1200px] mx-auto px-4 md:px-6">
              <Breadcrumb
                items={[
                  { label: '首页', href: '/' },
                  { label: category?.name || '分类', href: `/category/${article.category}` },
                  { label: article.title },
                ]}
              />
            </div>

            <div className="relative w-full h-[300px] md:h-[420px] overflow-hidden">
              <img
                src={article.image}
                alt={article.title}
                className="w-full h-full object-cover"
                title={article.title}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
            </div>

            <div className="max-w-[800px] mx-auto px-4 md:px-6 py-8 md:py-12">
              <div className="flex items-center gap-4 mb-6 flex-wrap">
                <Link
                  to={`/category/${article.category}`}
                  className="text-xs px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 whitespace-nowrap hover:bg-primary-200 transition-colors"
                >
                  {category?.name}
                </Link>
                <span className="text-sm text-foreground-400 whitespace-nowrap">
                  {article.readTime} 分钟阅读
                </span>
                <time dateTime={article.publishedAt} className="text-sm text-foreground-400 whitespace-nowrap">
                  {article.publishedAt}
                </time>
              </div>

              <h1 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-900 mb-6 leading-tight">
                {article.title}
              </h1>

              <p className="text-base text-foreground-600 leading-relaxed mb-10 border-l-4 border-primary-300 pl-4 italic">
                {article.excerpt}
              </p>

              {content && content.sections.map((section, idx) => (
                <div key={idx} className="mb-8">
                  <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-4">
                    {section.heading}
                  </h2>
                  {section.paragraphs.map((para, pIdx) => (
                    <p key={pIdx} className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                      {para}
                    </p>
                  ))}
                </div>
              ))}

              {!content && (
                <div className="text-foreground-700 leading-relaxed space-y-4">
                  <p>本文正在持续更新中，更多详细内容即将上线。请先浏览其他精选文章了解更多私密健康知识。</p>
                  <p>女性私密健康是每位女性都应该关注的重要话题。我们致力于提供最科学、最全面的健康科普内容，帮助你更好地了解自己的身体。</p>
                </div>
              )}
            </div>
          </article>

          {relatedArticles.length > 0 && (
            <section className="py-12 md:py-16 bg-background-100">
              <div className="max-w-[1200px] mx-auto px-4 md:px-6">
                <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-8 text-center">
                  相关文章推荐
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                  {relatedArticles.map((ra) => (
                    <ArticleCard
                      key={ra.id}
                      slug={ra.slug}
                      title={ra.title}
                      excerpt={ra.excerpt}
                      image={ra.image}
                      category={ra.category}
                      categoryName={getCategoryName(ra.category)}
                      readTime={ra.readTime}
                      publishedAt={ra.publishedAt}
                    />
                  ))}
                </div>
              </div>
            </section>
          )}
        </main>
        <Footer />
      </div>
    </>
  );
}